(function () {
  function showModal(modal) {
    modal.style.display = 'block';
    modal.classList.remove('closing');
    // Trigger animation after display is set
    requestAnimationFrame(() => {
      modal.classList.add('active');
    });
  }

  function hideModal(modal) {
    modal.classList.add('closing');
    modal.classList.remove('active');
    // Wait for animation to complete before hiding
    setTimeout(() => {
      modal.style.display = 'none';
      modal.classList.remove('closing');
    }, 300);
  }

    function stripSizeChartWhitespace() {
    document.querySelectorAll('.size-chart-table').forEach((tableWrapper) => {
      Array.from(tableWrapper.childNodes).forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          tableWrapper.removeChild(node);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.size-chart-trigger').forEach((opener) => {
      const targetSelector = opener.getAttribute('data-modal');
      if (!targetSelector) return;

      const modal = document.querySelector(targetSelector);
      if (!modal) return;

      const triggerButton = opener.querySelector('.size-chart-button');
      if (triggerButton) {
        triggerButton.addEventListener('click', (event) => {
          event.preventDefault();
          showModal(modal);
        });
      }

      modal.querySelectorAll('.size-chart-modal__close').forEach((closeButton) => {
        closeButton.addEventListener('click', () => hideModal(modal));
      });
      
      // Close on overlay click
      const overlay = modal.querySelector('.modal-overlay');
      if (overlay) {
        overlay.addEventListener('click', (e) => {
          if (e.target === overlay) {
            hideModal(modal);
          }
        });
      }
    });
    stripSizeChartWhitespace();
  });
})();
